import { WIDTH_DEFAULT } from "@/organisms/Drawers/const"
import { SbomTab } from "../SbomTab"
import { TabsDrawerTemplate } from "../TabsDrawerTemplate"
import { ConfigurationTabVirtualMachineDrawer } from "./components/ConfigurationTabVirtualMachineDrawer"
import { IssueTabVirtualMachineDrawer } from "./components/IssueTabVirtualMachineDrawer"
import { TitleVirtualMachineDrawer } from "./components/TitleVirtualMachineDrawer"

import type { VirtualMachineDrawerComponent } from "."

export const VirtualMachineDrawer: VirtualMachineDrawerComponent = (props) => {
  const { widthAdditive, ...restProps } = props

  return (
    <TabsDrawerTemplate
      name="VirtualMachineDrawer"
      tabs={["sbom", "scaIssues", "config"]}
      components={[
        SbomTab,
        IssueTabVirtualMachineDrawer,
        ConfigurationTabVirtualMachineDrawer
      ]}
      Title={TitleVirtualMachineDrawer}
      width={WIDTH_DEFAULT + widthAdditive}
      {...restProps}
    />
  )
}
